import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useToggle } from '../../../../../../hooks/use-toggle';
import { useCompanyStore } from '../../../../../../store/use-company-store';

export const useCompanyBase = () => {
  const [disabled, toggleDisabled, setDisabled] = useToggle(true);
  const {
    isLoading,
    handleSaveCompanyProfile,
    handleResetCompanyProfile,
    handleUpdateCompanyProfile,
    companyProfile,
  } = useCompanyStore();

  const { t } = useLang();
  const name = companyProfile?.name || '';

  const handleCancel = () => {
    handleResetCompanyProfile();
    setDisabled(true);
  };

  const handleSave = () => {
    handleSaveCompanyProfile().then(() => setDisabled(true));
  };

  const { handleCloseModal, handleOpenModal, isOpen } = useModalParams('companySensitive');

  return {
    disabled,
    toggleDisabled,
    isLoading,
    handleCancel,
    handleSave,
    t,
    name,
    handleUpdateCompanyProfile,
    companyProfile,
    handleCloseModal,
    handleOpenModal,
    isOpen,
  };
};
